import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { MediaQueryWrapper } from '@teliaee/telia-common-components';
import { ITabCordionProps, ITabsItemProps, TabCordion, TabsItem } from 'telia-front-react';

interface TabHeroInterface {
  hero?: React.ReactNode;
  tabProps: ITabsItemProps;
}

export interface TabHeroProps {
  tabCordionProps: ITabCordionProps;
  tabHeroes: TabHeroInterface[];
  defaultHero: React.ReactNode;
  isNode?: boolean;
}

interface TabHeroState {
  selectedTabHero: TabHeroInterface;
}

class TabHero extends React.Component<TabHeroProps, TabHeroState> {
  constructor(props: TabHeroProps | Readonly<TabHeroProps>) {
    super(props);
    this.state = { selectedTabHero: null };
  }

  public render() {
    return (
      <>
        {this.props.isNode ? (
          this.state.selectedTabHero?.hero ? (
            this.state.selectedTabHero.hero
          ) : (
            this.props.defaultHero
          )
        ) : (
          <>
            <MediaQueryWrapper
              maxWidth="md"
              matchingContent={this.props.defaultHero}
              unmatchingContent={this.state.selectedTabHero?.hero ? this.state.selectedTabHero.hero : this.props.defaultHero}
            />
          </>
        )}
        <TabCordion
          {...this.props.tabCordionProps}
          onTabChange={(_prevTab, nextTab) =>
            this.setState({
              selectedTabHero: this.props.tabHeroes.find((th) => th.tabProps.id === nextTab[0]),
            })
          }
        >
          {this.props.tabHeroes.map((th, index) => (
            <TabsItem {...th.tabProps} key={index} />
          ))}
        </TabCordion>
      </>
    );
  }
}

export default inject('isNode')(observer(TabHero));
